export const GetApplicationUserEdit = "/ApplicationUser/GetApplicationUserEdit";

export const ApplicationUserEdit = "/ApplicationUser/ApplicationUserEdit";

export const DownloadNationalCard = "/ApplicationUser/DownloadNationalCard";

export const DownloadPassport = "/ApplicationUser/DownloadPassport";
